import {WixSdk} from '@wix/js-sdk-wrapper';

export const OUTGOING_EVENTS = {
  INIT_REMOTE: 'remote-player.request.init-remote',
  PLAY: 'remote-player.request.play',
  PAUSE: 'remote-player.request.pause',
  CHANGE_TRACK: 'remote-player.request.change-track',
  TIME_UPDATE: 'remote-player.request.time-update',
};

/**
 * Transport from current window to widget. Done via WixSdk.PubSub
 * Emits play request to remote player.
 * Can request actions like play/pause track, change track.
 * Has additional event for requesting init remote player.
 */
export class OutgoingTransport {
  private originalComponentId: string;

  constructor(originalComponentId: string) {
    this.originalComponentId = originalComponentId;
  }

  _emit(eventName, data?) {
    if (!Object.values(OUTGOING_EVENTS).includes(eventName)) {
      throw new Error(`Unknown event ${eventName}`);
    }
    if (data && typeof data !== 'object') {
      throw new Error(`Data should be an object ${eventName}, ${data}`);
    }

    WixSdk.PubSub.publish(eventName, {...data, targetComponentId: this.originalComponentId});
  }

  emitPlaying({trackId}) {
    if (!trackId || typeof trackId !== 'number') {
      throw new Error('Invalid param trackId');
    }
    this._emit(OUTGOING_EVENTS.PLAY, {trackId});
  }

  emitPause({trackId}) {
    if (!trackId || typeof trackId !== 'number') {
      throw new Error('Invalid param trackId');
    }
    this._emit(OUTGOING_EVENTS.PAUSE, {trackId});
  }

  emitInit() {
    this._emit(OUTGOING_EVENTS.INIT_REMOTE);
  }

  emitChangeTrack({trackId}) {
    if (!trackId || typeof trackId !== 'number') {
      throw new Error('Invalid param trackId');
    }
    this._emit(OUTGOING_EVENTS.CHANGE_TRACK, {trackId});
  }

  emitTimeUpdate({trackId, currentTime}) {
    if (!trackId || typeof trackId !== 'number') {
      throw new Error('Invalid param trackId');
    }
    this._emit(OUTGOING_EVENTS.TIME_UPDATE, {trackId, currentTime});
  }
}
